import React from 'react';
import { motion } from "framer-motion";
import styled from 'styled-components/macro';

import { flexCenter } from 'styles/styled-mixins';


const Page = ({ className, children }) => (
    <PageMotion
        className={className}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
            duration: 0.5
        }}
    >
        <Inner>
            {children}
        </Inner>
    </PageMotion>
);


export default Page;


const PageMotion = styled(motion.div)`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	
	background-color: ${props => props.theme.app_background};
`;

const Inner = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	z-index: 1;
	
	${flexCenter};
	flex-direction: column;
`;
